<template>
  <div>
    <basic-container>
      <div style="height: 20px"></div>
      <el-form :inline="true" ref="form" :model="form">
        <el-row>
          <el-col span="6">
            <el-form-item label="项目名称" style="width: 100%; display: flex">
              <el-select
                style="width: 100%; flex: 1"
                v-model="form.projectId"
                placeholder="请选择项目"
                size="small"
              >
                <el-option
                  v-for="(item, index) in projectIdList"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="6">
            <el-form-item label="工单类型" style="width: 100%; display: flex">
              <el-select
                v-model="form.moduleType"
                placeholder="请选择工单类型"
                style="width: 100%"
              >
                <el-option
                  v-for="item in moduleTypeList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="6">
            <el-form-item label="年份" style="width: 100%; display: flex">
              <div style="width: 100%; flex: 1">
                <el-date-picker
                  style="width: 100%"
                  v-model="form.year"
                  value-format="yyyy"
                  type="year"
                  placeholder="请输入年份"
                >
                </el-date-picker>
              </div>
            </el-form-item>
          </el-col>
          <el-col span="6">
            <el-form-item>
              <el-button type="primary" @click="onSubmit">搜索</el-button>
              <el-button type="primary" @click="searchReset">清空</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <WebReport ref="WebReport" :url="url" :params="params"/>
    </basic-container>
  </div>
</template>

<script>
  import {
    modulesSetting
  } from "@/api/crmedical/order/order-add";
import { mapGetters } from 'vuex';
import { dateFormat } from "@/util/date";
import urlSettings from '@/config/url-settings';
import WebReport from '@/components/web-report';
import {getProjectList} from "@/api/crmedical/report/questionnaire.js";
export default {
  components: {
    WebReport,
  },
  data() {

    return {
      url: '',
      form: {
        projectId: [],
        moduleType: "",
        year: dateFormat(new Date()).substring(0,4),
      },
      moduleTypeList: [],
      projectList: [],
      oldOptions: [],
      params: {
          reportlet:urlSettings.VUE_APP_ENVIRONMENT +  '/workOrderYearReport.cpt',
      },
      dic: [],
    };
  },

  watch:{
    'form.projectId': function (val,oldVal) {
      if(val){
        this.modulesSetting(val);
      }
    },
  },
  methods: {
    modulesSetting(projectId){
      this.form.moduleType = "";
      modulesSetting(projectId).then((data)=>{
        let all = {
          dictValue:"全部",
          dictKey: "",
        };
        data.data.splice(0,0,all);
        console.log(data);
        this.moduleTypeList = data.data;
      });
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.params.projectId = this.form.projectId;
          this.params.moduleType = this.form.moduleType;
          if(!this.form.year){
            this.params.year ='';
          }else{
            this.params.year = this.form.year.substring(0,4);
          }
          setTimeout(() => {
            this.$refs.WebReport.regroupUrl();
          }, 0);
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    searchReset(){
      if (this.projectIdList.length > 0) {
        this.form.projectId = this.projectIdList[0].id;
      }
      this.form.year = dateFormat(new Date()).substring(0,4);
      this.form.moduleType = "";
      this.onSubmit();
    },

    initPropertyList() {
      getProjectList({}).then((res) => {
        this.projectIdList = res.data;
        if (this.projectIdList.length > 0) {
          this.form.projectId = this.projectIdList[0].id;
          this.modulesSetting(this.form.projectId);
        }

        var reportUrl = urlSettings.BASE_REPORT_URL;
        this.url = reportUrl.split('?')[0];

        this.params.projectId = `${this.projectIdList[0].id}`;
        this.params.moduleType = "";
        if(!this.form.year){
          this.params.year ='';
        }else{
          this.params.year = this.form.year;
        }
      setTimeout(() => {
          this.$refs.WebReport.regroupUrl();
        }, 0);
      });
    },
  },

  created() {
    this.initPropertyList();
  },
};
</script>

<style></style>
